<template>
	<q-page class="relative-position">
		<banner type_slug="portfolio" />

		<div :class="$q.platform.is.desktop ? 'custom-container q-pt-lg' : 'q-px-md'">
			<template v-if="courses.length === 0">
				<areas-skeleton v-for="(area, index) in 4" :key="`as${index}`" />
			</template>

			<template v-else>
				<areas :area="area" v-for="area in courses" :key="area.id" />
			</template>
		</div>

		<know-more />

		<div class="bg-primary">
			<div :class="$q.platform.is.desktop ? 'custom-container q-py-xl' : 'q-px-md'">
				<info />
			</div>
		</div>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Banner from 'components/portfolio/Banner'
import AreaSkeleton from 'components/portfolio/AreaSkeleton'
import Area from 'components/portfolio/Area'
import KnowMore from 'components/portfolio/KnowMore'
import Info from 'components/portfolio/Info'
import { createMetaMixin } from 'quasar'

export default {
	name: 'Portfolio',

	data() {
		return {
			slide_skeleton: 1,
			meta: {
				title: 'Portfolio',
				description: this.$t('platform_meta_description'),
			},
		}
	},

	mixins: [
		createMetaMixin(function () {
			return {
				title: this.meta.title,
				meta: {
					description: { name: 'description', content: this.meta.description },
				},
			}
		}),
	],

	computed: {
		...mapGetters({
			courses: 'portfolio/courses',
			country: 'portfolio/country',
		}),
	},

	components: {
		banner: Banner,
		areas: Area,
		'areas-skeleton': AreaSkeleton,
		'know-more': KnowMore,
		info: Info,
	},

	methods: {
		getCourses() {
			this.$axios
				.get(`/etraining_portfolio/group_trainings/${this.country.value}/`)
				.then((response) => {
					const courses = response.data.map((course) => {
						return {
							...course,
							group_trainings: course.group_trainings
								.map((gt) => ({ ...gt, slug: `${this.$slugify(gt.title)}-id-${gt.id}` }))
								.sort((a, b) => a.portfolio_order - b.portfolio_order),
						}
					})

					this.$store.dispatch('portfolio/SET_COURSES', [courses])
				})
				.catch((e) => {
					console.log(e)
				})
		},
	},

	mounted() {
		if (this.country) this.getCourses()
	},

	watch: {
		country: {
			handler: function (newValue) {
				if (this.country) this.getCourses()
			},
		},
	},
}
</script>

<style></style>
